// libraries.
import { Form } from 'react-bootstrap';

// styles.
import { StyledPropertyTypeCheckbox } from './styles';

interface PropertyTypeCheckboxProps {
  isChecked: boolean;
  onChange: (value: string) => void;
}

const DUPLEX_PROPERTY_TYPE = {
  value: '5',
  label: 'Dúplex',
};

export const PropertyTypeCheckbox = ({
  isChecked,
  onChange,
}: PropertyTypeCheckboxProps) => {
  const handleCheckboxChange = (checked: boolean) => {
    onChange(checked ? DUPLEX_PROPERTY_TYPE.value : '');
  };

  return (
    <StyledPropertyTypeCheckbox>
      <Form.Group className="d-flex flex-column pb-1" controlId="propertyType">
        <Form.Label className="text-start mb-0">Tipo de Inmueble</Form.Label>
        <Form.Check
          type="checkbox"
          id="duplex-checkbox"
          label={DUPLEX_PROPERTY_TYPE.label}
          checked={isChecked}
          onChange={e => handleCheckboxChange(e.target.checked)}
        />
      </Form.Group>
    </StyledPropertyTypeCheckbox>
  );
};
